import React from 'react';
import './TipTableHeader.scss';

interface TipTableHeaderProps {
  dates: string[];
}

const TipTableHeader: React.FC<TipTableHeaderProps> = ({ dates }) => {
  return (
    <div className="table-row table-header">
      <div className="table-cell col-user">Usuario</div>
      <div className="table-cell col-rate">Punto(%)</div>
      {dates.map(date => (
        <div key={date} className="table-cell col-day">
          <div className="day-label">
            <div className="day-name">
              {new Date(date).toLocaleDateString('es-CO', { weekday: 'short' })}
            </div>
            <div className="day-date">{date}</div>
          </div>
        </div>
      ))}
      <div className="table-cell col-total">Total Usuario</div>
    </div>
  );
};

export default TipTableHeader;
